import { useState } from "react";
import { useLanguage } from "../hooks/useLanguage";

const LANGS = [
  { code: "vi", flag: "VN", label: "Tiếng Việt" },
  { code: "en", flag: "EN", label: "English" },
  { code: "zh", flag: "ZH", label: "繁體中文" },
];

// 3 nút chọn ngôn ngữ inline — dùng trong More sheet trên mobile (dropdown khó dùng)
export function LangInline() {
  const { lang, setLang } = useLanguage();
  return (
    <div style={{ display: "flex", gap: 8 }}>
      {LANGS.map(l => (
        <button key={l.code} onClick={() => setLang(l.code)}
          style={{
            flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
            padding: "9px 6px", borderRadius: 8, fontSize: 13, cursor: "pointer",
            border: lang === l.code ? "1.5px solid #C8152A" : "1px solid #e5e7eb",
            background: lang === l.code ? "#FDECEA" : "#fff",
            fontWeight: lang === l.code ? 600 : 400, color: "#333",
          }}>
          <span style={{ fontSize: 14, fontWeight: 600, letterSpacing: 0.5 }}>{l.flag}</span>
        </button>
      ))}
    </div>
  );
}

export default function LangSwitcher() {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(false);
  const current = LANGS.find(l => l.code === lang) || LANGS[0];

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          display: "flex", alignItems: "center", gap: 6,
          padding: "6px 10px", borderRadius: 8, border: "1px solid #e5e7eb",
          background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 500,
          color: "#374151", width: "100%",
        }}
      >
        <span style={{ fontSize: 16 }}>{current.flag}</span>
        <span style={{ flex: 1, textAlign: "left" }}>{current.label}</span>
        <span style={{ fontSize: 10, color: "#aaa" }}>{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <>
          <div
            style={{ position: "fixed", inset: 0, zIndex: 999 }}
            onClick={() => setOpen(false)}
          />
          <div style={{
            position: "absolute", bottom: "calc(100% + 6px)", left: 0, right: 0,
            background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10,
            boxShadow: "0 4px 16px rgba(0,0,0,0.12)", zIndex: 1000, overflow: "hidden",
          }}>
            {LANGS.map(l => (
              <button
                key={l.code}
                onClick={() => { setLang(l.code); setOpen(false); }}
                style={{
                  display: "flex", alignItems: "center", gap: 8,
                  width: "100%", padding: "10px 14px", border: "none",
                  background: lang === l.code ? "#eff6ff" : "#fff",
                  cursor: "pointer", fontSize: 13,
                  fontWeight: lang === l.code ? 600 : 400,
                  color: lang === l.code ? "#1d4ed8" : "#374151",
                  borderBottom: "0.5px solid #f3f4f6",
                }}
              >
                <span style={{ fontSize: 16 }}>{l.flag}</span>
                {l.label}
                {lang === l.code && <span style={{ marginLeft: "auto" }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
